// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BottomText_Wrapper__3dVkP","TextBlack":"BottomText_TextBlack__3LNEj","TextOrange":"BottomText_TextOrange__2Zxjr","BorderLine":"BottomText_BorderLine__nKINa"};